module.exports = __webpack_public_path__ + "static/media/insect(1).54724712.PNG";